import { render, staticRenderFns } from "./CheckerboardColorSelector.vue?vue&type=template&id=354ff512"
import script from "./CheckerboardColorSelector.vue?vue&type=script&lang=js"
export * from "./CheckerboardColorSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports